var escape = require("../../../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@font-face{font-family:Comfortaa;font-weight:300;src:url(" + escape(require("./Comfortaa-Thin.ttf")) + ")}@font-face{font-family:Comfortaa;font-weight:400;src:url(" + escape(require("./Comfortaa-Regular.ttf")) + ")}@font-face{font-family:Comfortaa;font-weight:500;src:url(" + escape(require("./Comfortaa-Bold.ttf")) + ")}", ""]);

// exports
